import { render } from "./CertificationsView.vue?vue&type=template&id=3933f109"
import script from "./CertificationsView.vue?vue&type=script&lang=js"
export * from "./CertificationsView.vue?vue&type=script&lang=js"

import "./CertificationsView.vue?vue&type=style&index=0&id=3933f109&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__